import useAuth from 'hooks/useAuth';
import usePagination from 'hooks/usePagination';
import useTransactionApi from 'hooks/useTransactionApi';
import useWalletApi from 'hooks/useWalletApi';
import _get from 'lodash/get';
import _map from 'lodash/map';
import _size from 'lodash/size';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { IChain } from 'types/network';
import { IHeaderTable } from 'types/tables';
import { IFilterUser } from 'types/user';
import { TTransaction } from 'types/wallet';
import BackgroundCard from 'ui-component/cards/BackgroundCard';
import SkeletonRowTransactionDeposit from 'ui-component/Skeleton/SkeletonRowTransactionDeposit';
import TableBasic from 'ui-component/table/TableBasic';
import RowTransaction from 'views/pages/merchant/wallet/wallet-detail/components/deposit-withdraw/components/RowTransaction';

const columns: IHeaderTable[] = [
    {
        name: <FormattedMessage id="time-text" />
    },
    {
        name: <FormattedMessage id="type-text" />
    },

    {
        name: <FormattedMessage id="coin-text" />
    },
    {
        name: <FormattedMessage id="amount-text" />
    },
    {
        name: <FormattedMessage id="destination-text" />
    },
    {
        name: <FormattedMessage id="txid-text" />
    },
    {
        name: <FormattedMessage id="status-text" />
    }
];

const TransactionSection = ({ symbol = 'TCN', dataChainList }: { symbol: string; dataChainList: IChain[] }) => {
    const { currentPage, onChangePage } = usePagination();
    const filters = useMemo<IFilterUser & Partial<TTransaction>>(() => ({ page: currentPage - 1, size: 10 }), [currentPage]);
    const { user } = useAuth();
    const userId = useMemo(() => _get(user, 'id', null), [user]);

    const networkId = useMemo(() => _get(dataChainList, '[0].chainId', null), [dataChainList]);

    const { gGetSubUserIdOfMerchantData } = useWalletApi({
        symbol,
        enableWallet: true,
        networkId,
        merchantId: userId
    });

    const subUserId = useMemo(() => _get(gGetSubUserIdOfMerchantData, 'subUserId', null), [gGetSubUserIdOfMerchantData]);

    const {
        qGetTransactionsAll: { isLoading },
        dataTransactionAll,
        paginationTransactionAll
    } = useTransactionApi({
        filter: filters,
        enableTransaction: true,
        merchantId: userId,
        userId: subUserId
    });
    const totalPages = useMemo(() => _get(paginationTransactionAll, 'total_pages', 0), [paginationTransactionAll]);

    return (
        <BackgroundCard>
            <TableBasic
                column={columns}
                currentPage={filters.page}
                totalPages={totalPages}
                hasPagination
                handleSetPage={onChangePage}
                hasHeader
                isLoading={isLoading}
                loadingComponent={<SkeletonRowTransactionDeposit />}
                hasData={dataTransactionAll && _size(dataTransactionAll) > 0 && !isLoading}
            >
                <>
                    {_map(dataTransactionAll, (transaction: TTransaction) => (
                        <RowTransaction key={transaction.id} transaction={transaction} />
                    ))}
                </>
            </TableBasic>
        </BackgroundCard>
    );
};

export default TransactionSection;
